"use strict";

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalStep = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("@creditas/utils");

var _Step = require("./Step");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  className: _propTypes.string,
  direction: _propTypes.string,
  variant: _propTypes.string,
  color: _propTypes.string,
  icon: _propTypes.node,
  lastStep: _propTypes.bool,
  lineStyle: _propTypes.string,
  'data-testid': _propTypes.string,
  ref: (0, _propTypes.oneOfType)([_propTypes.func, (0, _propTypes.shape)({
    current: _propTypes.object
  })])
} : {};
var defaultProps = {
  component: 'div',
  direction: 'horizontal',
  variant: 'active'
};

var VerticalStep = function VerticalStep(_ref) {
  var testId = _ref['data-testid'],
      ref = _ref.ref,
      component = _ref.component,
      className = _ref.className,
      variant = _ref.variant,
      direction = _ref.direction,
      color = _ref.color,
      icon = _ref.icon,
      lastStep = _ref.lastStep,
      lineStyle = _ref.lineStyle,
      other = _objectWithoutProperties(_ref, ["data-testid", "ref", "component", "className", "variant", "direction", "color", "icon", "lastStep", "lineStyle"]);

  return (0, _core.jsx)(_Step.Step, (0, _extends2.default)({
    as: component,
    ref: ref,
    className: className,
    variant: "custom",
    direction: "vertical",
    color: color,
    icon: icon,
    lastStep: lastStep,
    lineStyle: lineStyle,
    "data-testid": testId
  }, other));
};

process.env.NODE_ENV !== "production" ? VerticalStep.propTypes = propTypes : void 0;
VerticalStep.defaultProps = defaultProps;
var WithForwardRef = (0, _utils.withForwardRef)(VerticalStep);
exports.VerticalStep = WithForwardRef;